import React, { useState } from 'react';
import css from './StatisticsSection.css';
import { useHistory } from 'react-router-dom';
import { IconEyeHideS } from '../../icons';
import StatisticsSectionActionsRider from './StatisticsSectionActionsRider';
import StatisticsSectionActionsHorse from './StatisticsSectionActionsHorse';
import { useScrollToParentNode } from './useScrollToParentNode';
import { useSelector } from 'react-redux';

export const STATISTICS_SECTION_ID = 'statistiken-und-pakete';

const StatisticsSection = ({ currentListing, packagesType, children }) => {
    const currentUser = useSelector(s => s.user.currentUser);

    const [parentRef, setRef] = useState(null);
    const history = useHistory();

    const { hash } = history.location;

    const { emailVerified } = currentUser?.attributes || {};
    const topbarHeight = 60;
    const emailConfirmationBar = 88;
    const offset = (emailVerified ? topbarHeight : topbarHeight + emailConfirmationBar) + 8; // 8 - small top padding

    const isUserPackageType = packagesType === 'profile';

    useScrollToParentNode({ hash, parentRef, offset });
    /**
     * manual-${STATISTICS_SECTION_ID} id is used to scroll down
     * to a section via js instead of plain #id html, see useScrollToParentNode
     */
    return (
        <section className={css.root} ref={setRef}>
            <div className={css.anchorElem} id={`manual-${STATISTICS_SECTION_ID}`} />
            <h4 className={css.title}>Statistiken & Pakete</h4>
            <p className={css.note}>
                <IconEyeHideS />
                <span>Nur für dich sichtbar</span>
            </p>

            {isUserPackageType && (
                <StatisticsSectionActionsRider
                    currentUser={currentUser}
                    currentListing={currentListing}
                />
            )}
            {!isUserPackageType && (
                <StatisticsSectionActionsHorse currentListing={currentListing} />
            )}
            {children}
        </section>
    );
};

export default StatisticsSection;
